import React, { PropsWithRef } from 'react';
import type { ReactElement } from 'react';
import { getUniqueId } from '@micro-apps/env';
export type Props = {
	id?: string;
	className?: string;
	leftLabel?: string;
	rightLabel?: string;
	theme?: 'light' | 'dark';
	defaultChecked?: boolean;
	checked?: boolean;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

export default function Switch({
	id = `${getUniqueId()}-switch`,
	className = '',
	leftLabel,
	rightLabel,
	theme = 'light',
	defaultChecked,
	checked,
	onChange,
}: PropsWithRef<Props>): ReactElement {
	return (
		<div className={`SwitchField SwitchField--${theme} ${className}`}>
			{leftLabel ? (
				<span className="SwitchField-label SwitchField-label--left">{leftLabel}</span>
			) : (
				''
			)}
			<label className="SwitchField-switch">
				<input
					className="SwitchField-checkbox"
					type="checkbox"
					name={id}
					id={id}
					checked={checked}
					defaultChecked={defaultChecked}
					onChange={onChange}
				/>
				<span className="SwitchField-slider"></span>
			</label>
			{rightLabel ? (
				<span className="SwitchField-label SwitchField-label--right">{rightLabel}</span>
			) : (
				''
			)}
		</div>
	);
}
